import { ArrowLeft } from "lucide-react";

const EMAIL = "info@xsalesconsulting.com";

// Rende **grassetto** e trasforma l'email in link mailto
const Rich = ({ text }) => {
  const parts = [];
  text.split(/(\*\*[^*]+\*\*)/g).forEach((seg, i) => {
    if (seg.startsWith("**")) {
      parts.push(<strong key={i} className="text-white">{seg.slice(2, -2)}</strong>);
    } else {
      seg.split(EMAIL).forEach((sub, j, arr) => {
        parts.push(sub);
        if (j < arr.length - 1) {
          parts.push(
            <a key={`${i}-${j}`} href={`mailto:${EMAIL}`} className="text-neon-cyan underline">{EMAIL}</a>
          );
        }
      });
    }
  });
  return <>{parts}</>;
};

export const LegalBlocks = ({ blocks }) => (
  <>
    {blocks.map((b, i) =>
      b.ul ? (
        <ul key={i} className="list-disc pl-5 mt-2 flex flex-col gap-1">
          {b.ul.map((li, j) => (
            <li key={j}><Rich text={li} /></li>
          ))}
        </ul>
      ) : (
        <p key={i} className={i > 0 ? "mt-3" : ""}><Rich text={b.p} /></p>
      )
    )}
  </>
);

export const LegalLayout = ({ title, updated, back = "Torna alla home", updatedLabel = "Ultimo aggiornamento", children }) => (
  <div className="bg-void text-white font-body min-h-screen">
    <div className="grain-overlay" />
    <div className="max-w-3xl mx-auto px-6 py-20">
      <a href="/" data-testid="legal-back-link" className="inline-flex items-center gap-2 text-sm text-neon-cyan hover:gap-3 transition-all mb-10">
        <ArrowLeft size={16} /> {back}
      </a>
      <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight mb-2">{title}</h1>
      <p className="text-xs text-white/40 mb-12">{updatedLabel}: {updated}</p>
      <div className="flex flex-col gap-8 text-sm text-white/70 leading-relaxed">{children}</div>
    </div>
  </div>
);

export const LegalSection = ({ title, children }) => (
  <section>
    <h2 className="font-display text-lg font-bold text-white mb-3">{title}</h2>
    {children}
  </section>
);
